// extracted by mini-css-extract-plugin
export var banner = "_t9-0";
export var settingRow = "_t9-2";
export var titleIcon = "_t9-1";